<template>
  <div>
    <b-card-body>
      <b-card class="importContainer">
        <b-form>
          <b-form-group :label="$t('escolha-blue')">
            <!-- Opção: Indicadores PGDI -->
            <div class="radio-option option-select mt-2">
              <label>
                <input class="cursor" type="radio" value="indicadorPGDI" v-model="localBlue.selectedOption" />
                <span class="cursor cursor-point">Indicadores PGDI</span>
              </label>

              <!-- Select com busca -->
              <b-input-group v-if="localBlue.selectedOption === 'indicadorPGDI'" class="align-items-center mt-2">
                <v-select
                  class="search-select flex-grow-1 cursor-point"
                  v-model="localBlue.productionIndicator"
                  :options="indicatorOptions"
                  label="text"
                  :reduce="opt => opt.value"
                  placeholder="Digite ou selecione um indicador"
                  :clearable="false"
                  :searchable="true"
                >
                  <template #no-options>Digite para filtrar…</template>
                </v-select>

                <b-input-group-prepend is-text class="icon-prepend cursor-point">
                  <img src="@/assets/buscar.png" width="25" height="25" alt="buscar" />
                </b-input-group-prepend>
              </b-input-group>
            </div>

            <!-- Opção: Gatilhos Disparados -->
            <div class="radio-option radio-top option-select">
              <label>
                <input class="cursor" type="radio" value="gatilhosDisparados" v-model="localBlue.selectedOption" />
                <span class="cursor cursor-point">Gatilhos Disparados</span>
              </label>
            </div>

            <!-- Opção: Gatilhos Tratados -->
            <div class="radio-option radio-top option-select">
              <label>
                <input class="cursor" type="radio" value="gatilhosTratados" v-model="localBlue.selectedOption" />
                <span class="cursor cursor-point">Gatilhos Tratados</span>
              </label>
            </div>
          </b-form-group>

          <!-- Botões -->
          <b-row class="groupBtn">
            <div class="modal-buttons">
              <img class="action-btn" width="30" height="30" src="@/assets/salvar.png" :title="$t('salvar')" @click="onSave" />
              <img class="action-btn ml-2 exit-btn" width="30" height="30" src="@/assets/sair.png" :title="$t('cancelar')" @click="onClose" />
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'BlueOptModal',
  components: { vSelect },
  props: {
    blueOpt: {
      type: Object,
      default: () => ({ selectedOption: 'indicadorPGDI', productionIndicator: '' })
    },
    indicators: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localBlue: { selectedOption: 'indicadorPGDI', productionIndicator: '' }
    }
  },
  computed: {
    indicatorOptions() {
      const uniqueIndicators = Array.from(new Map(
        this.indicators.map(ind => [ind.indicatorName, ind])
      ).values())
     
      return uniqueIndicators.map(ind => ({
        value: ind.indicatorName,
        text: ind.indicatorName
      }))
    }
  },
  created() {
    this.localBlue = { ...this.blueOpt }
    if (this.localBlue.productionIndicator === 'Gatilhos disparados') {
      this.localBlue.selectedOption = 'gatilhosDisparados'
    } else if (this.localBlue.productionIndicator === 'Gatilhos tratados') {
      this.localBlue.selectedOption = 'gatilhosTratados'
    } else {
      this.localBlue.selectedOption = 'indicadorPGDI'
    }
  },
  methods: {
    onSave() {
      if (this.localBlue.selectedOption === 'gatilhosDisparados') {
        this.localBlue.productionIndicator = 'Gatilhos disparados'
      } else if (this.localBlue.selectedOption === 'gatilhosTratados') {
        this.localBlue.productionIndicator = 'Gatilhos tratados'
      }
      this.$emit('save', { ...this.localBlue })
    },
    onClose() {
      this.$emit('close')
    }
  },
  watch: {
    blueOpt(newVal) {
      this.localBlue = { ...newVal }
      if (this.localBlue.productionIndicator === 'Gatilhos disparados') {
        this.localBlue.selectedOption = 'gatilhosDisparados'
      } else if (this.localBlue.productionIndicator === 'Gatilhos tratados') {
        this.localBlue.selectedOption = 'gatilhosTratados'
      } else {
        this.localBlue.selectedOption = 'indicadorPGDI'
      }
    }
  }
}
</script>

<style scoped>
.radio-option {
  margin-bottom: 10px;
}
.radio-option label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 16px;
}

.icon-prepend {
  margin-left: 8px;
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  padding-right: 6px;
}
.icon-prepend .input-group-text {
  background-color: transparent !important;
  border: none !important;
  padding: 0 6px;
}

.search-select .vs__dropdown-toggle {
  border: 1px solid #ced4da;
  cursor: pointer !important;
}
.search-select .vs__dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.search-select:hover .vs__dropdown-toggle,
.search-select:hover .vs__search,
.search-select:hover .vs__selected-options,
.search-select:hover .vs__actions {
  cursor: pointer;
}
.search-select .vs__search {
  cursor: pointer;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.modal-buttons {
  text-align: right;
  cursor: pointer;
}
.action-btn {
  border: none;
  background: transparent;
  cursor: pointer;
}
.exit-btn {
  margin-left: 14px;
  margin-right: 14px;
}
.cursor-point {
  cursor: pointer;
}
.radio-top {
  margin-top: 20px;
}

.option-select input[type='radio'] {
  accent-color: #009a9a;
  cursor: pointer;
}
</style>
